import React, { Fragment } from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import About from '../About/About';
import HeroTextCarousel from './HeroTextCarousel';
import './HeroImage.scss';

export default function HeroImage(props) {
  const useStyles = makeStyles((theme) => ({
    heroImage: {
      backgroundImage: `linear-gradient(to bottom, transparent 100%, white 0%), url(${props.isTermInsurance ? props.heroImageUrl ? props.heroImageUrl : '/product-landing/term/term-hero-image.png' : props.heroImageUrl})`,
      backgroundRepeat: 'no-repeat',
      [theme.breakpoints.up('xs')]: {
        backgroundSize: 'cover',
      },
      [theme.breakpoints.up('md')]: {
        backgroundImage: `linear-gradient(to bottom, transparent 100%, white 0%), url(${props.isTermInsurance ? props.heroImageTabletUrl ? props.heroImageTabletUrl : '/product-landing/term/term-hero-image.png' : props.heroImageTabletUrl})`,
        backgroundSize: 'cover',
      },
      [theme.breakpoints.down('xs')]: {
        backgroundImage: `linear-gradient(to bottom, transparent 100%, white 0%), url(${props.isTermInsurance ? props.heroImageMobileUrl ? props.heroImageMobileUrl : '/product-landing/term/term-hero-image.png' : props.heroImageMobileUrl})`,
        backgroundSize: 'cover',
      },
      [theme.breakpoints.down('md')]: {
        backgroundImage: `linear-gradient(to bottom, transparent 100%, white 0%), url(${props.isTermInsurance ? props.heroImageMobileUrl ? props.heroImageMobileUrl : '/product-landing/term/term-hero-mobile.png' : props.heroImageMobileUrl});`,
        backgroundSize: 'cover',
      },
      [theme.breakpoints.up('xl')]: {
        backgroundImage: `linear-gradient(to bottom, transparent  100%, white 0%), url(${props.isTermInsurance ? props.heroImageUrl ? props.heroImageUrl : '/product-landing/term/term-hero-image.png' : props.heroImageUrl})`,
      },
    },
  }));

  const classes = useStyles();

  return (
    <React.Fragment>
      {(!props.isTermInsurance && !props.isFinalExpense && !props.isWholeLife && !props.isUniversalLife && !props.isLoanProtection && !props.isBusinessSolutions) && <Term classes={classes} {...props}/>}
      {props.isTermInsurance && <TermInsurance classes={classes} {...props} />}
      {props.isFinalExpense && <FinalExpense classes={classes} {...props} />}
      {props.isWholeLife && <WholeLife classes={classes} {...props} />}
      {props.isUniversalLife && <UniversalLife classes={classes} {...props} />}
      {props.isLoanProtection && <LoanProtection classes={classes} {...props} />}
      {props.isBusinessSolutions && <BusinessSolutions classes={classes} {...props} />}
    </React.Fragment>
  );
}

export function Term(props) {
  const medicareNav = props.title === "Navigating Medicare" ? "medicare-subtitle" : "";

  return (
    <React.Fragment>
      <Row className={`landing-hero-image hero-image justify-content-center ${props.smallHero ? 'small-hero' : ''}`}>
        <div className={`background-image ${props.classes.heroImage}`}></div>
        <Container fluid className="content-section">
          <Col md="auto">
            <Row className="d-flex align-items-center hero-content">
              <Col lg className="text-wrapper d-flex flex-column">
                <Col lg className="text d-flex flex-column">
                  {props.heroText && <HeroTextCarousel carouselItems={props.heroText} cycleTime={3500} />}
                  {!props.heroText &&
                    <Fragment>
                      <h1>{props.title}</h1>
                      <div className={medicareNav}>
                        <h2>{props.subtitle}</h2>
                        {props.subtitleExtended && <p>{props.subtitleExtended}</p>}
                      </div>
                    </Fragment>
                  }
                </Col>
              </Col>

              <Col lg="auto" className={`hero-form ${props.hasQuickQuoteDisclaimer ? "has-disclaimer" : ""} `}>
                {props.form}
              </Col>
            </Row>
            {props.about &&
              <Row>
                <About title={props.about.title} content={props.about.content} disclaimer={props.about.disclaimer} />
              </Row>
            }
          </Col>
        </Container>
      </Row>
    </React.Fragment>
  );
}

export function TermInsurance(props) {
  return (
    <React.Fragment>
      <Row className='landing-hero-image'>
       <Container fluid className="content-section term-insurance m-0" >
            <Row>
              <Col className="text-wrapper d-flex flex-column col-lg-6 p-0">
                  <div className={`hero-background-image text d-flex flex-column ${props.classes.heroImage}`}>
                    <div className='blur-image-effect'>
                      <div className='image-text'>
                        {props.heroText && <HeroTextCarousel carouselItems={props.heroText} cycleTime={3500} />}
                        {!props.heroText &&
                          <Fragment>
                            <h1>{props.title}</h1>
                            <div>
                              <h2>{props.subtitle}</h2>
                              {props.subtitleExtended && <p>{props.subtitleExtended}</p>}
                            </div>
                          </Fragment>
                        }
                      </div>
                    </div>
                  </div>
              </Col>
              <Col lg="6" className={`hero-form ${props.hasQuickQuoteDisclaimer ? "has-disclaimer" : ""} `}>
                {props.form}
              </Col>
            </Row>
        </Container>
      </Row>
    </React.Fragment>
  );
}

export function FinalExpense(props) {
  return (
    <React.Fragment>
      <Row className='landing-hero-image'>
       <Container fluid className="content-section term-insurance m-0" >
            <Row>
              <Col className="text-wrapper d-flex flex-column col-lg-6 p-0">
                  <div className={`hero-background-image text d-flex flex-column ${props.classes.heroImage}`}>
                    <div className='blur-image-effect'>
                      <div className='image-text'>
                        {props.heroText && <HeroTextCarousel carouselItems={props.heroText} cycleTime={3500} />}
                        {!props.heroText &&
                          <Fragment>
                            <h1>{props.title}</h1>
                            <div>
                              <h2>{props.subtitle}</h2>
                              {props.subtitleExtended && <p>{props.subtitleExtended}</p>}
                            </div>
                          </Fragment>
                        }
                      </div>
                    </div>
                  </div>
              </Col>
              <Col lg="6" className={`hero-form ${props.hasQuickQuoteDisclaimer ? "has-disclaimer" : ""} `}>
                {props.form}
              </Col>
            </Row>
        </Container>
      </Row>
    </React.Fragment>
  );
}

export function WholeLife(props) {
  return (
    <React.Fragment>
      <Row className='landing-hero-image'>
       <Container fluid className="content-section term-insurance m-0" >
            <Row>
              <Col className="text-wrapper d-flex flex-column col-lg-6 p-0">
                  <div className={`hero-background-image text d-flex flex-column ${props.classes.heroImage}`}>
                    <div className='blur-image-effect'>
                      <div className='image-text'>
                        {props.heroText && <HeroTextCarousel carouselItems={props.heroText} cycleTime={3500} />}
                        {!props.heroText &&
                          <Fragment>
                            <h1>{props.title}</h1>
                            <div>
                              <h2>{props.subtitle}</h2>
                              {props.subtitleExtended && <p>{props.subtitleExtended}</p>}
                            </div>
                          </Fragment>
                        }
                      </div>
                    </div>
                  </div>
              </Col>
              <Col lg="6" className={`hero-form ${props.hasQuickQuoteDisclaimer ? "has-disclaimer" : ""} `}>
                {props.form}
              </Col>
            </Row>
        </Container>
      </Row>
    </React.Fragment>
  );
}

export function UniversalLife(props) {
  return (
    <React.Fragment>
      <Row className='landing-hero-image'>
       <Container fluid className="content-section term-insurance m-0" >
            <Row>
              <Col className="text-wrapper d-flex flex-column col-lg-6 p-0">
                  <div className={`hero-background-image text d-flex flex-column ${props.classes.heroImage}`}>
                    <div className='blur-image-effect'>
                      <div className='image-text'>
                        {props.heroText && <HeroTextCarousel carouselItems={props.heroText} cycleTime={3500} />}
                        {!props.heroText &&
                          <Fragment>
                            <h1>{props.title}</h1>
                            <div>
                              <h2>{props.subtitle}</h2>
                              {props.subtitleExtended && <p>{props.subtitleExtended}</p>}
                            </div>
                          </Fragment>
                        }
                      </div>
                    </div>
                  </div>
              </Col>
              <Col lg="6" className={`hero-form ${props.hasQuickQuoteDisclaimer ? "has-disclaimer" : ""} `}>
                {props.form}
              </Col>
            </Row>
        </Container>
      </Row>
    </React.Fragment>
  );
}

export function LoanProtection(props) {
  return (
    <React.Fragment>
      <Row className='landing-hero-image'>
       <Container fluid className="content-section term-insurance m-0" >
            <Row>
              <Col className="text-wrapper d-flex flex-column col-lg-6 p-0">
                  <div className={`hero-background-image text d-flex flex-column ${props.classes.heroImage}`}>
                    <div className='blur-image-effect'>
                      <div className='image-text'>
                        {props.heroText && <HeroTextCarousel carouselItems={props.heroText} cycleTime={3500} />}
                        {!props.heroText &&
                          <Fragment>
                            <h1>{props.title}</h1>
                            <div>
                              <h2>{props.subtitle}</h2>
                              {props.subtitleExtended && <p>{props.subtitleExtended}</p>}
                            </div>
                          </Fragment>
                        }
                      </div>
                    </div>
                  </div>
              </Col>
              <Col lg="6" className={`hero-form ${props.hasQuickQuoteDisclaimer ? "has-disclaimer" : ""} `}>
                {props.form}
              </Col>
            </Row>
        </Container>
      </Row>
    </React.Fragment>
  );
}

export function BusinessSolutions(props) {
  return (
    <React.Fragment>
      <Row className={"landing-hero-image hero-image justify-content-center tight-hero"}>
        <div className={`background-image ${props.classes.heroImage}`}></div>
        <Container fluid className="content-section business-solutions">
          <Col md="auto">
            <Row className="d-flex align-items-center hero-content">
              <Col lg className="text-wrapper d-flex flex-column">
                <Col lg className="text d-flex flex-column text-carousel-wrapper">
                  {props.heroText && <HeroTextCarousel carouselItems={props.heroText} cycleTime={3500} />}
                  {!props.heroText &&
                    <Fragment>
                      <h1>{props.title}</h1>
                      <div>
                        <h2>{props.subtitle}</h2>
                        {props.subtitleExtended && <p>{props.subtitleExtended}</p>}
                      </div>
                    </Fragment>
                  }
                </Col>
              </Col>
            </Row>
          </Col>
        </Container>
      </Row>
    </React.Fragment>
  );
}

HeroImage.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  about: PropTypes.object,
  heroText: PropTypes.array,
  hasQuickQuoteDisclaimer: PropTypes.bool,
  smallHero: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/LandingPages/HeroImage/HeroImage.js